import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

/**
 * Resource Hints Component
 * Adds DNS prefetch, preconnect, and other performance hints
 */
export const ResourceHints = () => {
  return (
    <Helmet>
      {/* DNS Prefetch for external resources */}
      <link rel="dns-prefetch" href="https://fonts.googleapis.com" />
      <link rel="dns-prefetch" href="https://fonts.gstatic.com" />
      
      {/* Preconnect to critical third-party origins */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
    </Helmet>
  );
};

/**
 * Page-specific resource preloader
 * Use this for preloading page-specific critical resources
 */
export const usePageResourcePreload = (resources: string[]) => {
  useEffect(() => {
    resources.forEach(resource => {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = resource;
      document.head.appendChild(link);
    });
  }, [resources]);
};
